'use strict';

class Encounter {
    constructor($scope){
        this.$scope = $scope;
        this.useCR = false;
        this.characters = [];
        this.monsters = [];
        this.results=[];
        this.info = {};
        this.xp = {
            easy:0,
            medium:0,
            hard:0,
            deadly:0
        };
        this.xpLookup = [
            [25,50,75,100],
            [50,100,150,200],
            [75,150,225,400],
            [125,250,375,500],
            [250,500,750,1100],
            [300,600,900,1400],
            [350,750,1100,1700],
            [450,900,1400,2100],
            [550,1100,1600,2400],
            [600,1200,1900,2800],
            [800,1600,2400,3600],
            [1000,2000,3000,4500],
            [1100,2200,3400,5100],
            [1250,2500,3800,5700],
            [1400,2800,4300,6400],
            [1600,3200,4800,7200],
            [2000,3900,5900,8800],
            [2100,4200,6300,9500],
            [2400,4900,7300,10900],
            [2800,5700,8500,12700]
        ];
        this.groupCats = [
            "нет",
            "один",
            "пара",
            "группа",
            "банда",
            "толпа",
            "орда"
        ];
        this.multiplierLookup = [
            0.5,
            1,
            1.5,
            2,
            2.5,
            3,
            4,
            5
        ];
        this.crLookup = [
            {name:"0",value:0},{name:"1/8", value:25},{name:"1/4", value:50},{name:"1/2",value:100}
        ];

        this.crXPLookup = [
            25,
            50,
            100,
            200,
            450,
            700,
            1100,
            1800,
            2300,
            2900,
            3900,
            5000,
            5900,
            7200,
            8400,
            10000,
            11500,
            13000,
            15000,
            18000,
            20000,
            22000,
            25000,
            33000,
            41000,
            50000,
            62000,
            75000,
            90000,
            105000,
            120000,
            135000,
            155000
        ];

        for(let i=1; i<=30; i++)
        {
            this.crLookup.push({name: i, value: this.crXPLookup[i+2]});
        }

        this.characters.push({level:1, number: 0});
        this.monsters.push({cr:0,xp:0, number: 0});
    }

    calculate(){
        this.results = [];
        let easyXP = 0,
            mediumXP = 0,
            hardXP = 0,
            deadlyXP = 0;

        this.charactersNumber = 0;

        this.characters.forEach((chara)=>{
           let number = chara.number;
           this.charactersNumber+=parseInt(chara.number);
           let level = chara.level;
           if(level>=0 && number>0)
           {
               easyXP += this.xpLookup[level][0] * number;
               mediumXP += this.xpLookup[level][1] * number;
               hardXP += this.xpLookup[level][2] * number;
               deadlyXP += this.xpLookup[level][3] * number;
           }
        });

        this.xp.easy = easyXP;
        this.xp.medium = mediumXP;
        this.xp.hard = hardXP;
        this.xp.deadly = deadlyXP;

        this.results.push({name: "Лёгкий", exp: easyXP});
        this.results.push({name: "Средний", exp: mediumXP});
        this.results.push({name: "Сложный", exp: hardXP});
        this.results.push({name: "Смертельный", exp: deadlyXP});
    }

    monsterCalculate(){

        this.calculate();
        let totalXP = 0;
        let monsterTotal = 0;

        this.monsters.forEach((mon)=>{
           let number = mon.number;
           monsterTotal += parseInt(mon.number);
           let xp = this.useCR ? mon.cr : mon.xp;
           totalXP += number * xp;
        });

        this.monstersNumber = monsterTotal;

        let multiplier = 0;
        if (this.monstersNumber > 0) multiplier++;
        if (this.monstersNumber > 1) multiplier++;
        if (this.monstersNumber > 2) multiplier++;
        if (this.monstersNumber > 6) multiplier++;
        if (this.monstersNumber > 10) multiplier++;
        if (this.monstersNumber > 14) multiplier++;

        let groupCategory = this.groupCats[multiplier];
        let partySize = "";

        if (this.charactersNumber < 1){
               multiplier++;
            partySize = " (нет)";
        } else if (this.charactersNumber >= 1 && this.charactersNumber < 3) {
            multiplier++;
            partySize = " (маленькая команда)";
        } else if (this.charactersNumber >= 6){
            multiplier--;
            partySize = " (большая команда)";
        }

        let cr = this.getCR(totalXP * this.multiplierLookup[multiplier]);

        this.info.charas = this.charactersNumber + partySize;
        this.info.monsters = monsterTotal + " (" + groupCategory + ")";
        this.info.exp = totalXP + " XP" + (this.charactersNumber ? " (" + Math.floor(totalXP / this.charactersNumber) + " опыта каждому)" : "")
        this.info.difficulty = this.multiplierLookup[multiplier];
        this.info.rating = totalXP * this.multiplierLookup[multiplier] + "XP";
        this.info.enccr = cr;

        this.comparison(totalXP * this.multiplierLookup[multiplier],this.charactersNumber);
    }

    comparison(encounter,characterTotal){
        let c = "";
        if (characterTotal > 0){
            if (encounter < this.xp.easy){
                c = "Простейшая";
            } else if (encounter < this.xp.medium){
                c = "Лёгкая";
            } else if (encounter < this.xp.hard){
                c = "Средняя";
            } else if (encounter < this.xp.deadly){
                c = "Сложная";
            } else {
                c = "Смертельная";
            }
        } else {
            c = "Невозможно вычислить";
        }

        this.encdifficulty = c;
    }

    getCR(xp){
        let cr = 0;
        for (let i=0;i<this.crXPLookup.length;i++){
            if (this.crXPLookup[i] <= xp) cr++;
        }
        return this.crLookup[cr].name;
    }
}
Encounter.$inject = ['$scope'];

export {Encounter};